module.exports = __webpack_public_path__ + "img/viralcure-logo.2711ccf0.svg";